import { ReactComponent as Icon } from '../../assets/icons/pricing.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" />;
}
